import * as React from 'react'
import { styled } from 'next-yak'

import * as glyphs from '../../../icons/glyphs'
import * as styles from '../../../styles'

export type MembershipProjectCardProps = {
  avatar: string
  backgroundImage: string
  className?: string
  description?: string
  isFinished?: boolean
  projectName: string
  size?: 'small' | 'large'
  showSubscriptionsCount?: boolean
  translations: {
    members: string
    subscribe: string
    subscribed: string
  }
  userRole?: 'editor' | 'fan' | 'moderator' | 'owner' | 'supporter' | 'coordinator'
} & React.JSX.IntrinsicElements['div']

function MembershipProjectCardComponent({
  avatar,
  backgroundImage,
  className,
  description,
  isFinished = false,
  projectName,
  translations,
  showSubscriptionsCount = false,
  size = 'small',
  userRole,
}: MembershipProjectCardProps): React.ReactElement<any> {
  return (
    <styles.card.project.MembershipProjectCardWrapper className={className} $size={size}>
      <styles.card.project.MembershipProjectCardBackdrop $backgroundImage={backgroundImage}>
        {description && <styles.copy.S.regular>{description}</styles.copy.S.regular>}
        {avatar && <styles.image.Avatar type={size === 'large' ? 'extra-large' : 'large'} src={avatar} withShadow />}
      </styles.card.project.MembershipProjectCardBackdrop>
      <styles.card.project.MembershipProjectCardContent>
        <styles.card.project.MembershipProjectCardTitle>{projectName}</styles.card.project.MembershipProjectCardTitle>
        <styles.card.project.MembershipProjectCardSubtitle>
          {userRole === 'supporter' ? (
            <styles.card.project.MembershipProjectCardFooterLeft>
              {size === 'small' ? (
                <>
                  <glyphs.stroke.Check size={13} />
                  <styles.copy.XS.regular>{translations.subscribed}</styles.copy.XS.regular>
                </>
              ) : (
                <>
                  <glyphs.stroke.Check size={18} />
                  <styles.copy.S.regular>{translations.subscribed}</styles.copy.S.regular>
                </>
              )}
            </styles.card.project.MembershipProjectCardFooterLeft>
          ) : (
            <>
              {showSubscriptionsCount && (
                <styles.card.project.MembershipProjectCardFooterLeft>
                  {size === 'small' ? (
                    <>
                      <glyphs.stroke.Person size={13} />
                      <styles.copy.XS.regular>{translations.members}</styles.copy.XS.regular>
                    </>
                  ) : (
                    <>
                      <glyphs.stroke.Person size={18} />
                      <styles.copy.S.regular>{translations.members}</styles.copy.S.regular>
                    </>
                  )}
                </styles.card.project.MembershipProjectCardFooterLeft>
              )}
              {!isFinished && (
                <styles.card.project.MembershipProjectCardFooterRight>
                  {size === 'small' ? (
                    <styles.copy.XS.semiBold>{translations.subscribe}</styles.copy.XS.semiBold>
                  ) : (
                    <styles.copy.S.semiBold>{translations.subscribe}</styles.copy.S.semiBold>
                  )}
                </styles.card.project.MembershipProjectCardFooterRight>
              )}
            </>
          )}
        </styles.card.project.MembershipProjectCardSubtitle>
      </styles.card.project.MembershipProjectCardContent>
    </styles.card.project.MembershipProjectCardWrapper>
  )
}

export const MembershipProjectCard = styled(MembershipProjectCardComponent)``
